import {initActions} from '@dized/ui/dist/redux/ActionHelper';
import {call, get} from '@dized/ui/dist/redux/RequestHelper';

const path = '/api/v1/user/Sessions';

export default initActions('SessionActions', {
  COOKIES_ACCEPTED: () => call(),
  VALIDATE: () => get(`${path}/validate`),
});
